import { Typography } from '@statsbomb/kitbag-components';
import { LegendRadar, RadarData } from '@statsbomb/kitbag-datavis';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

export interface RadarLegendItem {
  id: string;
  name: string;
  data: RadarData[];
  colour?: string;
}

export const RadarComparisonLegend = ({ radars }: { radars: [RadarLegendItem, RadarLegendItem] }) => {
  const { t } = useTranslation('radar');
  const theme = useTheme();

  const defaultColours = [
    theme.colours.visualisations.dataObjects.forAgainst.for.main,
    theme.colours.visualisations.dataObjects.forAgainst.against.main,
  ];

  return (
    <div
      role="group"
      aria-label={t('legend.comparisonAriaLabel')}
      className="flex flex-wrap gap-x-8 gap-y-4 w-fit mx-auto"
    >
      {radars.map(({ id, name, data, colour }, index) => (
        <div key={id} className="flex items-center gap-4">
          <div className="w-12 h-12">
            <LegendRadar id={id} data={data} colour={colour || defaultColours[index]} />
          </div>
          <Typography variant="headingMedium" as="span">
            {name}
          </Typography>
        </div>
      ))}
    </div>
  );
};
